import Error from './../view/Error';
export default [
  {
    path: '/error/:key',
    element: Error,
    meta: {
      title: '',
      isHeader: true, //是否展示顶部header
    },
  },
];
